export const CAR_DIFF_PATHS_TO_OMIT = ['hash', 'image', 'symbol', 'assignedDriver'];
